module.exports = __webpack_public_path__ + "Tinebase/js/ace-soy_template-FAT.js";